import { render } from "./MainPersonalPayment.vue?vue&type=template&id=32eace6d&scoped=true"
import script from "./MainPersonalPayment.vue?vue&type=script&lang=js"
export * from "./MainPersonalPayment.vue?vue&type=script&lang=js"

import "./MainPersonalPayment.vue?vue&type=style&index=0&id=32eace6d&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32eace6d"]])

export default __exports__